export default __webpack_public_path__ + "static/media/Glitter wave_primary.daa5660b.jpg";